"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AzureWrap = void 0;
var _react = _interopRequireDefault(require("react"));
var _msalReact = require("@azure/msal-react");
var _msalBrowser = require("@azure/msal-browser");
var _propTypes = _interopRequireDefault(require("prop-types"));
var defaultAuth = _interopRequireWildcard(require("./_auth"));
var _AzureContent = require("./AzureContent");
var _Types = require("../Types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const getInstance = function getInstance() {
  let authFile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return new _msalBrowser.PublicClientApplication(authFile ? authFile.msalConfig : defaultAuth.msalConfig);
};

/**
 * Azure wrap
 * @param {Element: required} children content
 * @param {Required} authFile File to set login settings, if null - default auth file for local development is used
 * @param {JSX.Element} loginComponent Custom login page, only as a Tag
 * @example
 * loginComponent={<LoginPage />}
 *
 * @returns {JSX.Element}
 * @public
 */

const AzureWrap = _ref => {
  let {
    children,
    authFile = null,
    loginComponent
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_msalReact.MsalProvider, {
    instance: getInstance(authFile)
  }, /*#__PURE__*/_react.default.createElement(_AzureContent.AzureContent, {
    authFile: authFile,
    loginComponent: loginComponent
  }, children));
};
exports.AzureWrap = AzureWrap;
AzureWrap.propTypes = {
  children: _propTypes.default.element.isRequired,
  authFile: _Types.AuthFileType,
  loginComponent: _propTypes.default.element
};
AzureWrap.defaultProps = {
  authFile: null,
  loginComponent: null
};